import React from "react";
import { Tabs, Tab, Box } from "@mui/material";

/**
 * Reusable FilterTabs component for tab-based data filtering
 * 
 * @param {number} value - Active tab index
 * @param {Function} onChange - Tab change handler: (newValue) => void
 * @param {Array} tabs - Array of tab definitions: [{ label, value?, count? }]
 * @param {object} sx - Custom styles
 */
const FilterTabs = ({
  value = 0,
  onChange,
  tabs = [],
  sx = {},
}) => {
  return (
    <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3, ...sx }}>
      <Tabs value={value} onChange={(e, newValue) => onChange?.(newValue)}>
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            label={
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {tab.label}
                {tab.count !== undefined && (
                  <Box
                    sx={{
                      bgcolor: "primary.main",
                      color: "white",
                      borderRadius: "12px",
                      px: 1,
                      py: 0.25,
                      fontSize: "0.75rem",
                      fontWeight: 600,
                    }}
                  >
                    {tab.count}
                  </Box>
                )}
              </Box>
            }
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default FilterTabs;

